/* eslint-disable import/prefer-default-export */
const IMPERSONATE_COOKIE_NAME = "kcImp";

export { IMPERSONATE_COOKIE_NAME };
